import is from '@sindresorhus/is';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { FeaturedOpportunityOptions } from '~/shared/data-contract/featured-learning-opportunities';
import { featuredOpportunityOptionsSchema } from '~/shared/data-contract/featured-learning-opportunities';
import type { Pathname } from '~/shared/http-fetcher/http-fetcher';

import { learningOpportunityKeys } from './query-keys';

export const useFeaturedOpportunityOptionsQuery = (
    featuredOpportunityId: string,
): UseQueryResult<FeaturedOpportunityOptions> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);
    const pathname: Pathname = `/featured-opportunities/${featuredOpportunityId}/options`;

    return useQuery({
        enabled: is.nonEmptyString(featuredOpportunityId),
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(featuredOpportunityOptionsSchema, {
                pathname,
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: learningOpportunityKeys.featuredOptions(featuredOpportunityId),
        throwOnError: false,
    });
};
